import { useEscapeKeydown } from "@/hooks/useEscapeKeyDown";
import { useLenis } from "lenis/react";
import React, { useEffect } from "react";

interface ModalProps {
  children?: React.ReactNode;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  absolutePosition?: boolean;
}

type ModalContextProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  absolutePosition: boolean;
};

const ModalContext = React.createContext<ModalContextProps | null>(null);

export function useModal() {
  const context = React.useContext(ModalContext);

  if (!context) {
    throw new Error("useModal must be used within <ModalRoot />");
  }

  return context;
}

const ModalRoot = ({
  children,
  open: openProps,
  setOpen: setOpenProps,
  absolutePosition = false,
}: ModalProps) => {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const open = openProps ?? internalOpen;
  const setOpen = setOpenProps ?? setInternalOpen;
  const lenis = useLenis();
  useEscapeKeydown((event) => {
    //const isHighestLayer = index === context.layers.size - 1;
    //if (!isHighestLayer) return;
    if (!event.defaultPrevented) {
      event.preventDefault();
      setOpen(false);
    }
  });

  useEffect(() => {
    if (!absolutePosition) {
      // assuming that absolutePosition is used the modal is shown in some container like google maps - then we do not want to prevent scrolling
      if (open) {
        lenis?.stop();
      } else {
        lenis?.start();
      }
    }
  }, [open, lenis, absolutePosition]);

  return (
    <ModalContext.Provider value={{ open, setOpen, absolutePosition }}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalRoot;
